<div [formGroup]="formGroup" formContainerCol class="pt-2">
  @if (showEnergySource) {
    <bo-energy-source-dropdown
      [required]="true"
      formControlName="energySource"
    ></bo-energy-source-dropdown>
  }

  <area-dropdown
    type="market"
    [energySource]="energySource$ | async"
    placeholder="{{ 'time-series-identifier.MARKET_AREA' | transloco }}"
    formControlName="marketAreaId"
    [useIntAsId]="true"
    [clearable]="true"
  ></area-dropdown>

  <area-dropdown
    type="delivery"
    [energySource]="energySource$ | async"
    placeholder="{{ 'load-profile.fields.DELIVERY_AREA' | transloco }}"
    formControlName="deliveryAreaId"
    [useIntAsId]="true"
    [clearable]="true"
  ></area-dropdown>

  <bo-kam-dropdown
    formControlName="kamIds"
    [energySource]="energySource$ | async"
  ></bo-kam-dropdown>

  <mat-form-field>
    <mat-label>{{ 'company.segment.NAME' | transloco }}</mat-label>

    <mat-select formControlName="segmentId">
      <mat-option [value]="null" selected
        >{{ 'common.NO_SELECTION' | transloco }}
      </mat-option>
      @for (option of segments$ | async; track option.id) {
        <mat-option [value]="option.id">{{ option.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'master-data.YEARS' | transloco }}</mat-label>
    <mat-select formControlName="years" multiple>
      @for (year of years; track year) {
        <mat-option [value]="year">{{ year }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <bo-companies-dropdown formControlName="companyIds"></bo-companies-dropdown>

  @if (showHknTypes) {
    <mat-form-field>
      <mat-label>{{ 'master-data.HKN_CERTIFICATE' | transloco }}</mat-label>
      <mat-select formControlName="hknTypeIds" multiple>
        @for (hknType of hknTypes$ | async; track hknType.id) {
          <mat-option [value]="hknType.id">{{ hknType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <!-- <input
  type="text"
  class="date-range"
  ngxDaterangepickerMd
  formControlName="selectedRange"
  [alwaysShowCalendars]="true"
  drops="up"
  opens="right"
  [showDropdowns]="true"
  [locale]="locale"
  [showClearButton]="true"
  placeholder="{{ 'dashboard.CREATE_DATE_RANGE' | transloco }}"
  /> -->

  <ui-date-range
    [customLabel]="customDateRangeLabel()"
    formGroupName="selectedRange"
  ></ui-date-range>
</div>
